/**
 * The media background of a screen is "black" or "white" - nothing else exists on the player. This is the SAME mapping the backend applies
 * (App\Services\MediaBackground::normalise, backend a286562e) and the player (MediaBackground.normalise, build 422): lowercase + trim; "white" or a
 * white hex ((#)fff / (#)ffffff) -> white; everything else (a colour, empty, null, garbage) -> black. Never white by accident.
 */
export const MEDIA_BG_BLACK = 'black';
export const MEDIA_BG_WHITE = 'white';

const HEX_WHITE = /^#?(f{3}|f{6})$/;

export function normaliseMediaBackground(value) {
  if (typeof value !== 'string') return MEDIA_BG_BLACK;
  const v = value.trim().toLowerCase();
  return v === MEDIA_BG_WHITE || HEX_WHITE.test(v) ? MEDIA_BG_WHITE : MEDIA_BG_BLACK;
}
